import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseRatingNumber',
  props: {
    rating: {},
    maxRate: { default: 100 }
  },
  setup(__props: any) {

const props = __props;

const ratingClass = computed((): string => {
  if (props.rating < props.maxRate / 5) {
    return 'blue';
  }
  if (props.rating < (props.maxRate / 5) * 2) {
    return 'green';
  }
  if (props.rating < (props.maxRate / 5) * 3) {
    return 'yellow';
  }
  if (props.rating < (props.maxRate / 5) * 4) {
    return 'orange';
  }

  return 'darkOrange';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([ratingClass.value, "rating"])
  }, _toDisplayString(_ctx.rating), 3))
}
}

})